import { render, staticRenderFns } from "./edit-lab.vue?vue&type=template&id=1cb8b653&"
import script from "./edit-lab.vue?vue&type=script&lang=js&"
export * from "./edit-lab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports